module.exports = __webpack_public_path__ + "img/smg49_samurai01_shop.9ffe9c5b.png";